import { FC } from 'react';
import { graphql, usePreloadedQuery, PreloadedQuery, useFragment } from 'react-relay';
import PreQuoteDutiesDescription from '../shared/delivery/PreQuoteDutiesDescription';

import { PreloadedCheckoutDutiesQuery } from './__generated__/PreloadedCheckoutDutiesQuery.graphql';
import { PreloadedCheckoutDuties_shipmentQuote$key } from './__generated__/PreloadedCheckoutDuties_shipmentQuote.graphql';

type PreloadedCheckoutDutiesProps = {
    queryReference: PreloadedQuery<PreloadedCheckoutDutiesQuery>;
    shipmentQuote: PreloadedCheckoutDuties_shipmentQuote$key | null;
};

export type QueryType = PreloadedCheckoutDutiesQuery;
export const query = graphql`
    query PreloadedCheckoutDutiesQuery(
        $buyerId: String
        $itemId: String
        $destinationCountry: String
        $shipmentQuoteId: String
    ) {
        viewer {
            ...PreQuoteDutiesDescription_viewer
        }
    }
`;

export const PreloadedCheckoutDuties: FC<PreloadedCheckoutDutiesProps> = ({
    queryReference,
    shipmentQuote: shipmentQuoteRef,
}) => {
    const { viewer } = usePreloadedQuery<PreloadedCheckoutDutiesQuery>(query, queryReference);

    const shipmentQuote = useFragment(
        graphql`
            fragment PreloadedCheckoutDuties_shipmentQuote on ShipmentQuote {
                ...PreQuoteDutiesDescription_shipmentQuote
            }
        `,
        shipmentQuoteRef
    );

    {
        return <PreQuoteDutiesDescription viewer={viewer} shipmentQuote={shipmentQuote} />;
    }
};
